// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";

// Whole-app maintenance switch: while on, every route redirects to /maintenance.
export const maintenanceSlice = createSlice({
    name: "maintenance",
    initialState: { isOn: false },
    reducers: {
        setMaintenance: (state, action) => {
            state.isOn = Boolean(action.payload);
        }
    }
});

export const { setMaintenance } = maintenanceSlice.actions;

export default maintenanceSlice.reducer;
